import React from 'react'
import {Box, Button, Container, IconButton, Typography} from '@mui/material'
import {IconAccess, IconAdd, IconEmail, IconFotos, IconTeam, IconTrip, IconTripMap} from '../Icons'
import {PageProps} from '../components/PageRouter'

export default function StartPage({session}: PageProps) {
  return (
    <Container maxWidth="md">
      <Box my={5}>
        <Typography variant="h2">Welcome!</Typography>
        <Typography variant="body1" mt={2}>
          Thank you for checking out FotoLog. Here is a quick introduction of how to use this application. Clicking your
          avatar image in the upper right will show the top-level navigation. Clickable things will be highlighted as
          buttons & icons like so: &nbsp;
        </Typography>
        <Box mx="auto" textAlign="center" my={1}>
          <Button variant="contained" color="primary" size="small" sx={{px: 3, py: 1}} href="./add-trip">
            <IconAdd /> &nbsp; Add Trip
          </Button>
        </Box>
        <Typography variant="body1" my={2}>
          The core of FotoLog is comprised of Trips <IconTrip color="secondary" /> and their Fotos{' '}
          <IconFotos color="secondary" />. Once you're ready, add a Trip and then upload some Fotos. Some notes about
          geographical (geo) data:
        </Typography>
        <ul>
          <li>
            Geo data will attempt to be automatically extracted from your Fotos, so make sure your device is configured
            to allow geo data to be included. This is typically the default.
          </li>
          <li>Fotos from older devices may have inaccurate or no geo data.</li>
          <li>Geo data can be manually specified by you after uploading.</li>
        </ul>
      </Box>
      <Box my={5}>
        <Typography variant="h2" display="flex">
          <IconButton href="/trips" color="primary" sx={{fontSize: '2rem'}}>
            <IconTripMap sx={{mr: 2, fontSize: '3rem'}} />
            Your Trips
          </IconButton>
        </Typography>
        <Typography variant="body1" pl="1rem">
          See all of your Trips where you can drill down to specific ones to view or manage. The more data you provide
          (titles, descriptions, tags), the easier it will be to browse & filter your content as it grows.
        </Typography>
      </Box>
      {session.scope.isTeamLead && (
        <Box my={5}>
          <Typography variant="h2" display="flex">
            <IconButton href="/team" color="primary" sx={{fontSize: '2rem'}}>
              <IconTeam sx={{mr: 2, fontSize: '3rem'}} />
              Your Team
            </IconButton>
          </Typography>
          <Typography variant="body1" pl="1rem">
            Teams are primarily designed for families or groups of friends. As a Team lead, you can view & manage the
            content of any member account. Plus, sharing amongst your Team is easier. Team leads can view content as a
            Team member by choosing "Manage" from the main navigation. Anything you do while managing another will be
            done as that member, so be careful not to create anything intended for your account.
          </Typography>
        </Box>
      )}
      <Box my={5}>
        <Typography variant="h2" display="flex">
          <IconButton href="/acl" color="primary" sx={{fontSize: '2rem'}}>
            <IconAccess sx={{mr: 2, fontSize: '3rem'}} />
            Access Rules
          </IconButton>
        </Typography>
        <Typography variant="body1" pl="1rem">
          These rules govern who will be able to view Trip content. This section can be ignored if you do not plan to
          share with your Team.
        </Typography>
      </Box>
      <Box my={5}>
        <Typography variant="h2" display="flex">
          <IconButton href="/email" color="primary" sx={{fontSize: '2rem'}}>
            <IconEmail sx={{mr: 2, fontSize: '3rem'}} />
            Email
          </IconButton>
        </Typography>
        <Typography variant="body1" pl="1rem">
          All notifications that FotoLog has emailed can be viewed here as well.
        </Typography>
      </Box>
    </Container>
  )
}
